import { render, staticRenderFns } from "./RequestBranchButton.vue?vue&type=template&id=0be4fc35&scoped=true&"
import script from "./RequestBranchButton.vue?vue&type=script&lang=js&"
export * from "./RequestBranchButton.vue?vue&type=script&lang=js&"
import style0 from "./RequestBranchButton.vue?vue&type=style&index=0&id=0be4fc35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be4fc35",
  null
  
)

export default component.exports